import angular from 'angular';
import MediaListing from '../../cmsCore/MediaModules/MediaListing/MediaListing';
import UnsplashListing from '../../cmsCore/MediaModules/Unsplash/UnsplashListing/UnsplashListing'

let mediaPageModule = angular.module('cms.media.page', [MediaListing, UnsplashListing])
    .component('mediaPageView', {
            template: require('./media.html'),
            controller: function () {
                this.activeTab = 1;

                this.setActiveTab = (number) => {
                    this.activeTab = number;
                }
            }
        },
    );
export default mediaPageModule.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Media/MediaPageDirective.js